<template>
<div class="chapter">
<div class="inner_page">
<h2 class="sec_chap">Abbreviations</h2>
<h3 class="sub_section">German</h3>
<h4 class="sub_level">a) Listed in order of unit size</h4>
<table class="table0">
<tbody><tr>
<td class="td1">AG</td>
<td class="td2">army group</td>
</tr>
<tr>
<td class="td1">A</td>
<td class="td2">army</td>
</tr>
<tr>
<td class="td1">Pz A</td>
<td class="td2">panzer army</td>
</tr>
<tr>
<td class="td1">AC</td>
<td class="td2">army corps</td>
</tr>
<tr>
<td class="td1">MotC</td>
<td class="td2">motorized corps</td>
</tr>
<tr>
<td class="td1">ID</td>
<td class="td2">infantry division</td>
</tr>
<tr>
<td class="td1">PzD</td>
<td class="td2">panzer division</td>
</tr>
<tr>
<td class="td1">MotD</td>
<td class="td2">motorized division</td>
</tr>
<tr>
<td class="td1">CavD</td>
<td class="td2">cavalry division</td>
</tr>
<tr>
<td class="td1">MtnD</td>
<td class="td2">mountain division</td>
</tr>
<tr>
<td class="td1">Sec. D</td>
<td class="td2">security division</td>
</tr>
<tr>
<td class="td1">IB</td>
<td class="td2">infantry brigade</td>
</tr>
<tr>
<td class="td1">PzB</td>
<td class="td2">panzer brigade</td>
</tr>
<tr>
<td class="td1">AR</td>
<td class="td2">artillery regiment</td>
</tr>
<tr>
<td class="td1">IR</td>
<td class="td2">infantry regiment</td>
</tr>
<tr>
<td class="td1">PzR</td>
<td class="td2">panzer regiment</td>
</tr>
<tr>
<td class="td1">EngR</td>
<td class="td2">engineer regiment</td>
</tr>
<tr>
<td class="td1">MotR</td>
<td class="td2">motorized regiment</td>
</tr>
<tr>
<td class="td1">MtrcR</td>
<td class="td2">motorcycle regiment</td>
</tr>
<tr>
<td class="td1">Bn</td>
<td class="td2">battalion</td>
</tr>
<tr>
<td class="td1">EngBn</td>
<td class="td2">engineer battalion</td>
</tr>
<tr>
<td class="td1">Co</td>
<td class="td2">company</td>
</tr>
<tr>
<td class="td1">Btry</td>
<td class="td2">battery</td>
</tr>
</tbody></table>
<h4 class="sub_level">b) Listed alphabetically by abbreviation</h4>
<table class="table0">
<tbody><tr>
<td class="td1">A</td>
<td class="td2">army</td>
</tr>
<tr>
<td class="td1">AC</td>
<td class="td2">army corps</td>
</tr>
<tr>
<td class="td1">AG</td>
<td class="td2">army group</td>
</tr>
<tr>
<td class="td1">AR</td>
<td class="td2">artillery regiment</td>
</tr>
<tr>
<td class="td1">Bn</td>
<td class="td2">battalion</td>
</tr>
<tr>
<td class="td1">Btry</td>
<td class="td2">battery</td>
</tr>
<tr>
<td class="td1">CavD</td>
<td class="td2">cavalry division</td>
</tr>
<tr>
<td class="td1">Co</td>
<td class="td2">company</td>
</tr>
<tr>
<td class="td1">EngBn</td>
<td class="td2">engineer battalion</td>
</tr>
<tr>
<td class="td1">EngR</td>
<td class="td2">engineer regiment</td>
</tr>
<tr>
<td class="td1">IB</td>
<td class="td2">infantry brigade</td>
</tr>
<tr>
<td class="td1">ID</td>
<td class="td2">infantry division</td>
</tr>
<tr>
<td class="td1">IR</td>
<td class="td2">infantry regiment</td>
</tr>
<tr>
<td class="td1">MotC</td>
<td class="td2">motorized corps</td>
</tr>
<tr>
<td class="td1">MotD</td>
<td class="td2">motorized division</td>
</tr>
<tr>
<td class="td1">MotR</td>
<td class="td2">motorized regiment</td>
</tr>
<tr>
<td class="td1">MtnD</td>
<td class="td2">mountain division</td>
</tr>
<tr>
<td class="td1">MtrcR</td>
<td class="td2">motorcycle regiment</td>
</tr>
<tr>
<td class="td1">Pz</td>
<td class="td2">A panzer army</td>
</tr>
<tr>
<td class="td1">PzB</td>
<td class="td2">panzer brigade</td>
</tr>
<tr>
<td class="td1">PzD</td>
<td class="td2">panzer division</td>
</tr>
<tr>
<td class="td1">PzR</td>
<td class="td2">panzer regiment</td>
</tr>
<tr>
<td class="td1">Sec. D</td>
<td class="td2">security division</td>
</tr>
</tbody></table>
<h3 class="sub_section">Soviet</h3>
<h4 class="sub_level">a) Listed in order of unit size</h4>
<table class="table0">
<tbody><tr>
<td class="td1">A</td>
<td class="td2">army</td>
</tr>
<tr>
<td class="td1">MC</td>
<td class="td2">mechanized corps</td>
</tr>
<tr>
<td class="td1">RC</td>
<td class="td2">rifle corps</td>
</tr>
<tr>
<td class="td1">CG</td>
<td class="td2">cavalry group</td>
</tr>
<tr>
<td class="td1">RD</td>
<td class="td2">rifle division</td>
</tr>
<tr>
<td class="td1">TD</td>
<td class="td2">tank division</td>
</tr>
<tr>
<td class="td1">MD</td>
<td class="td2">motorized division</td>
</tr>
<tr>
<td class="td1">MRD</td>
<td class="td2">motorized rifle division</td>
</tr>
<tr>
<td class="td1">CD</td>
<td class="td2">cavalry division</td>
</tr>
<tr>
<td class="td1">DNO</td>
<td class="td2">People’s militia division</td>
</tr>
<tr>
<td class="td1">BAD</td>
<td class="td2">bomber aviation division</td>
</tr>
<tr>
<td class="td1">FAD</td>
<td class="td2">fighter aviation division</td>
</tr>
<tr>
<td class="td1">MAD</td>
<td class="td2">mixed aviation division</td>
</tr>
<tr>
<td class="td1">RB</td>
<td class="td2">rifle brigade</td>
</tr>
<tr>
<td class="td1">TB</td>
<td class="td2">tank brigade</td>
</tr>
<tr>
<td class="td1">MRB</td>
<td class="td2">motorized rifle brigade</td>
</tr>
<tr>
<td class="td1">FR</td>
<td class="td2">fortified region</td>
</tr>
<tr>
<td class="td1">RR</td>
<td class="td2">rifle regiment</td>
</tr>
<tr>
<td class="td1">AR</td>
<td class="td2">artillery regiment</td>
</tr>
<tr>
<td class="td1">ATR</td>
<td class="td2">antitank artillery regiment</td>
</tr>
<tr>
<td class="td1">CAR</td>
<td class="td2">corps artillery regiment</td>
</tr>
<tr>
<td class="td1">GAR</td>
<td class="td2">gun artillery regiment</td>
</tr>
<tr>
<td class="td1">HAR</td>
<td class="td2">howitzer artillery regiment</td>
</tr>
<tr>
<td class="td1">MtrR</td>
<td class="td2">mortar regiment</td>
</tr>
<tr>
<td class="td1">TR</td>
<td class="td2">tank regiment</td>
</tr>
<tr>
<td class="td1">MRR</td>
<td class="td2">motorized rifle regiment</td>
</tr>
<tr>
<td class="td1">CR</td>
<td class="td2">cavalry regiment</td>
</tr>
<tr>
<td class="td1">RAS</td>
<td class="td2">reconnaissance aviation squadron</td>
</tr>
<tr>
<td class="td1">RBn</td>
<td class="td2">rifle battalion</td>
</tr>
<tr>
<td class="td1">TBn</td>
<td class="td2">tank battalion</td>
</tr>
<tr>
<td class="td1">AABn</td>
<td class="td2">antiaircraft artillery battalion</td>
</tr>
<tr>
<td class="td1">ATBn</td>
<td class="td2">antitank battalion</td>
</tr>
<tr>
<td class="td1">AutoBn</td>
<td class="td2">automobile battalion</td>
</tr>
<tr>
<td class="td1">BEPO</td>
<td class="td2">armored train</td>
</tr>
<tr>
<td class="td1">Bn</td>
<td class="td2">battalion</td>
</tr>
<tr>
<td class="td1">Co</td>
<td class="td2">company</td>
</tr>
<tr>
<td class="td1">Btry</td>
<td class="td2">battery</td>
</tr>
<tr>
<td class="td1">Gds.</td>
<td class="td2">guards</td>
</tr>
<tr>
<td class="td1">Sep.</td>
<td class="td2">separate</td>
</tr>
<tr>
<td class="td1" colspan="2">G (as a prefix with any abbrev.)      guards</td>
</tr>
</tbody></table>
<h4 class="sub_level">b) Listed alphabetically by abbreviation</h4>
<table class="table0">
<tbody><tr>
<td class="td1">A</td>
<td class="td2">army</td>
</tr>
<tr>
<td class="td1">AABn</td>
<td class="td2">antiaircraft artillery battalion</td>
</tr>
<tr>
<td class="td1">AR</td>
<td class="td2">artillery regiment</td>
</tr>
<tr>
<td class="td1">ATBn</td>
<td class="td2">antitank battalion</td>
</tr>
<tr>
<td class="td1">ATR</td>
<td class="td2">antitank artillery regiment</td>
</tr>
<tr>
<td class="td1">AutoBn</td>
<td class="td2">automobile battalion</td>
</tr>
<tr>
<td class="td1">BAD</td>
<td class="td2">bomber aviation division</td>
</tr>
<tr>
<td class="td1">BEPO</td>
<td class="td2">armored train</td>
</tr>
<tr>
<td class="td1">Bn</td>
<td class="td2">battalion</td>
</tr>
<tr>
<td class="td1">Btry</td>
<td class="td2">battery</td>
</tr>
<tr>
<td class="td1">CAR</td>
<td class="td2">corps artillery regiment</td>
</tr>
<tr>
<td class="td1">CD</td>
<td class="td2">cavalry division</td>
</tr>
<tr>
<td class="td1">CG</td>
<td class="td2">cavalry group</td>
</tr>
<tr>
<td class="td1">Co</td>
<td class="td2">company</td>
</tr>
<tr>
<td class="td1">CR</td>
<td class="td2">cavalry regiment</td>
</tr>
<tr>
<td class="td1">DNO</td>
<td class="td2">People’s Militia division</td>
</tr>
<tr>
<td class="td1">FAD</td>
<td class="td2">fighter aviation division</td>
</tr>
<tr>
<td class="td1">FR</td>
<td class="td2">fortified region</td>
</tr>
<tr>
<td class="td1" colspan="2">G (as a prefix with any abbrev.)      guards</td>
</tr>
<tr>
<td class="td1">GAR</td>
<td class="td2">gun artillery regiment</td>
</tr>
<tr>
<td class="td1">Gds.</td>
<td class="td2">guards</td>
</tr>
<tr>
<td class="td1">HAR</td>
<td class="td2">howitzer artillery regiment</td>
</tr>
<tr>
<td class="td1">MAD</td>
<td class="td2">mixed aviation division</td>
</tr>
<tr>
<td class="td1">MC</td>
<td class="td2">mechanized corps</td>
</tr>
<tr>
<td class="td1">MD</td>
<td class="td2">motorized division</td>
</tr>
<tr>
<td class="td1">MRB</td>
<td class="td2">motorized rifle brigade</td>
</tr>
<tr>
<td class="td1">MRD</td>
<td class="td2">motorized rifle division</td>
</tr>
<tr>
<td class="td1">MRR</td>
<td class="td2">motorized rifle regiment</td>
</tr>
<tr>
<td class="td1">MtrR</td>
<td class="td2">mortar regiment</td>
</tr>
<tr>
<td class="td1">RAS</td>
<td class="td2">reconnaissance aviation squadron</td>
</tr>
<tr>
<td class="td1">RB</td>
<td class="td2">rifle brigade</td>
</tr>
<tr>
<td class="td1">RBn</td>
<td class="td2">rifle battalion</td>
</tr>
<tr>
<td class="td1">RC</td>
<td class="td2">rifle corps</td>
</tr>
<tr>
<td class="td1">RD</td>
<td class="td2">rifle division</td>
</tr>
<tr>
<td class="td1">RR</td>
<td class="td2">rifle regiment</td>
</tr>
<tr>
<td class="td1">Sep.</td>
<td class="td2">separate</td>
</tr>
<tr>
<td class="td1">TB</td>
<td class="td2">tank brigade</td>
</tr>
<tr>
<td class="td1">TBn</td>
<td class="td2">tank battalion</td>
</tr>
<tr>
<td class="td1">TD</td>
<td class="td2">tank division</td>
</tr>
<tr>
<td class="td1">TR</td>
<td class="td2">tank regiment</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Abbreviations.vue?457b54f8